import React from 'react';
import { Card, CardContent } from "@material-ui/core";

function LastUpdate() {
    return (
        <Card>
            <CardContent>
                <h2>Updated on: 9/1/2026</h2>
            </CardContent>
        </Card>
    )
}

export default LastUpdate;